export enum Events {
  BodyCreated = 'BodyCreated',
  BodyDestroyed = 'BodyDestroyed',
  ColliderAdded = 'ColliderAdded',
  ColliderRemoved = 'ColliderRemoved',
  JointAdded = 'JointAdded',
  JointRemoved = 'JointRemoved',
  CollisionStart = 'CollisionStart',
  Collide = 'Collide',
  CollisionEnd = 'CollisionEnd',
  PreStep = 'PreStep',
  IslandPreStep = 'IslandPreStep',
  IslandPostStep = 'IslandPostStep',
  PostStep = 'PostStep',
  FallAsleep = 'FallAsleep',
  Awake = 'Awake',
}
